import { c as _c } from "react/compiler-runtime";
import { Sparkles } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useBuyerAssistantEnabled } from "@/api/use-buyer-assistant";
import { AssistantPanel } from "./assistant-panel";

// Плавающая кнопка «Помощник» на всех страницах витрины (SiteLayout).
// Видна, только если шлюз включил помощника (`/buyer/assistant/status`):
// пока флаг выключен или ручки нет, на витрине ничего не меняется.
//
// Десктоп — тёмная пилюля «Помощник» в правом нижнем углу (24px от краёв);
// < 1024px — круглая кнопка 52px над таб-баром (67px + safe-area + 16px),
// чтобы не перекрывать его пункты.
// Не показываем там, где внизу экрана своё поле ввода или оплата: в «Чатах»
// кнопка легла бы на «Отправить», в оформлении — на кнопку оплаты.
const HIDDEN_ON = ["/chats", "/checkout", "/pay/"];
export function AssistantLauncher() {
  const $ = _c(12);
  const {
    t
  } = useTranslation();
  const enabled = useBuyerAssistantEnabled();
  const {
    pathname
  } = useLocation();
  const [open, setOpen] = useState(false);
  if (!enabled) {
    return null;
  }
  if (open) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <AssistantPanel onClose={() => setOpen(false)} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (HIDDEN_ON.some(prefix => pathname.startsWith(prefix))) {
    return null;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setOpen(true);
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("assistant.launcher");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Sparkles className="size-[22px] text-ds-accent lg:size-5" strokeWidth={1.75} aria-hidden="true" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("assistant.launcher");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="hidden text-[15px] leading-5 font-semibold lg:inline">{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <button type="button" onClick={t0} aria-label={t1} aria-haspopup="dialog" data-testid="assistant-launcher" className="fixed right-4 bottom-[calc(83px+env(safe-area-inset-bottom))] z-40 flex size-[52px] items-center justify-center gap-2 rounded-full bg-ds-primary text-white shadow-[0_8px_24px_rgba(0,0,0,0.22)] outline-none transition-[transform,background-color] hover:bg-ds-ink-2 focus-visible:ring-2 focus-visible:ring-ds-accent focus-visible:ring-offset-2 active:scale-95 lg:right-6 lg:bottom-6 lg:h-12 lg:w-auto lg:px-5">{t2}{t4}</button>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}